import { FamilyHome } from "../FamilyHome.jsx";

// V63.2 — NerdMusic Games family home.
//
// REQUIRED: this wrapper exists so the /games/music URL resolves to a
// family-subgrid page instead of 404'ing. V63.1 shipped without one
// and the History family 404'd until V63.1.1 patched it. Don't repeat.

function MusicFamilySeo() {
  return (
    <>
      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "0 0 12px" }}>
        Music games — theory you play, not theory you read
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Music theory in a textbook is rules. Music theory in a game is
        consequence — your D minor feels like dread; your driving texture
        feels like chase. NerdMusic games turn the rules into decisions
        with audible payoff. The vocabulary follows, because you've
        already heard what it means.
      </p>

      <h2 style={{ color: "#E8E9F3", fontSize: 19, margin: "24px 0 12px" }}>
        What's here
      </h2>
      <p style={{ margin: "0 0 16px" }}>
        Film Scoring — you're scoring a thriller. Five cues, four choices
        per cue, three meters watching. The film won't change from your
        score; your score will change everything else.
      </p>

      <p style={{ margin: "0 0 16px", color: "#7C8099", fontStyle: "italic" }}>
        More music games on the roadmap. Chord-progression building and
        ear training are each their own kind of game.
      </p>
    </>
  );
}

export default function MusicHome() {
  return <FamilyHome familyId="music" seoContent={<MusicFamilySeo />} />;
}
